module.exports = __webpack_public_path__ + "img/downArrow.aa3efbe7.svg";